import React, { ReactNode } from 'react';
import { CurrentItemDesc } from '../../CurrentItemDesc';
import { CurrentItemLocationSection } from '../../CurrentItemLocationSection';
import { FullItemData } from '../../CurrentItemSections/types';

interface LocationDescriptionBlockProps {
  item: FullItemData;
  currentItemDescTitle: string | ReactNode;
  isLeased: boolean;
}

export const LocationDescriptionBlock: React.FC<
  LocationDescriptionBlockProps
> = ({ item, currentItemDescTitle, isLeased }) => (
  <>
    {item?.description && (
      <CurrentItemDesc
        title={currentItemDescTitle}
        description={item?.description}
      />
    )}
    <CurrentItemLocationSection
      city={item?.city?.name}
      address={item?.address}
      lat={item?.latitude}
      lng={item?.longitude}
      nearestLocations={item?.nearestLocations}
      isLeased={isLeased}
      categorySlug={item?.category?.slug || ''}
    />
  </>
);
